import * as React from 'react';
import PropTypes from 'prop-types';
import { createIntl, FormattedMessage } from 'react-intl';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../contexts/language';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import IconButton from '@mui/material/IconButton';
import SnackBar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Link } from 'gatsby-theme-material-ui';
import AlertTitle from '@mui/material/AlertTitle';
import { useLanguageLink } from '../../hooks/useLanguageLink';

const languages = {
  ar,
  en
};


export const FavoriteButton = ({ favorite, onToggleFavorite, outlined, sx }) => {
  const localeConfig = React.useContext(LocaleContext);
  const [showAddedOk, setShowAddedOk] = React.useState(false);
  const [showRemovedOk, setShowRemovedOk] = React.useState(false);
  const [showAddedFail, setShowAddedFail] = React.useState(false);
  const [showRemovedFail, setShowRemovedFail] = React.useState(false);
  const intl = createIntl({
    locale: localeConfig.lang,
    messages: languages[localeConfig?.lang] || languages.en
  });
  const l = useLanguageLink();
  return (
    <>

      <IconButton
        onClick={() => {
          if (!favorite) {
            onToggleFavorite()?.then(() => setShowAddedOk(true))?.catch(() => setShowAddedFail(true));
          } else {
            onToggleFavorite()?.then(() => setShowRemovedOk(true))?.catch(() => setShowRemovedFail(true));
          }
        }}
        disabled={typeof onToggleFavorite !== 'function'}
        sx={{
          border: outlined ? '1px solid' : undefined,
          backgroundColor: 'white',
          zIndex: 3,
          ...sx
        }}
        title={favorite ? intl.formatMessage({
          id: 'FavoriteAndAvailability.RemoveFromFavourites',
          defaultMessage: 'Remove From Favourites'
        }) : intl.formatMessage({
          id: 'FavoriteAndAvailability.AddToMyFavourites',
          defaultMessage: 'Add to Favourites'
        })}
      >
        {favorite ? <FavoriteIcon color={'secondary'} /> : <FavoriteBorderIcon />}
      </IconButton>
      <SnackBar
        sx={{
          zIndex: 30000
        }}
        open={showAddedOk}
        autoHideDuration={10000}
        onClose={() => setShowAddedOk(false)}
      >
        <Alert onClose={() => setShowAddedOk(false)} severity="success" sx={{ width: '100%', zIndex: 30000 }}>
          <AlertTitle><FormattedMessage id={'FavoriteAndAvailability.addOkSnack'}
            defaultMessage="Added to Favourites" /></AlertTitle>
          <FormattedMessage
            id="FavoriteAndAvailability.visitCompare"
            defaultMessage="<a>Compare</a> your favorites"
            values={{
              a: chunks => (
                <Link
                  to={l('/compare/')}
                >
                  {chunks}
                </Link>
              ),
            }}
          />
        </Alert>
      </SnackBar>
      <SnackBar
        open={showRemovedOk}
        autoHideDuration={10000}
        onClose={() => setShowRemovedOk(false)}
      >
        <Alert onClose={() => setShowRemovedOk(false)} severity="success" sx={{ width: '100%', zIndex: 30000 }}>
          <FormattedMessage id={'FavoriteAndAvailability.removeOkSnack'} defaultMessage="Removed From Favourites" />
        </Alert>
      </SnackBar>
      <SnackBar
        open={showAddedFail}
        autoHideDuration={10000}
        onClose={() => setShowAddedFail(false)}
      >
        <Alert onClose={() => setShowAddedFail(false)} severity="error" sx={{ width: '100%', zIndex: 30000 }}>
          <FormattedMessage id={'FavoriteAndAvailability.addFailSnack'} defaultMessage="Unable to add to Favourites" />
        </Alert>
      </SnackBar>
      <SnackBar
        open={showRemovedFail}
        autoHideDuration={10000}
        onClose={() => setShowRemovedFail(false)}
      >
        <Alert onClose={() => setShowAddedFail(false)} severity="error" sx={{ width: '100%', zIndex: 30000000 }}>
          <FormattedMessage id={'FavoriteAndAvailability.removedFailSnack'}
            defaultMessage="Unable to remove from Favourites" />
        </Alert>
      </SnackBar>

    </>
  );
};

FavoriteButton.propTypes = {
  favorite: PropTypes.bool,
  onToggleFavorite: PropTypes.func,
  outlined: PropTypes.bool,
  sx: PropTypes.shape({})
};
FavoriteButton.defaultProps = {
  favorite: false,
  outlined: false,
  sx: {}
};

export default FavoriteButton;